export default class KdiagramCalculationResultTableData {
  constructor(
    consumption,
    power,
    powerIntervalInKw,
    powerIntervalInPercentage,
    speed,
    rpm,
    isoDailyConsumption,
    auxiliaryConsumption,
    measuredIsoConsumption,
    medianMeasuredConsumption,
  ) {
    this.consumption = consumption;
    this.power = power;
    this.powerIntervalInKw = powerIntervalInKw;
    this.powerIntervalInPercentage = powerIntervalInPercentage;
    this.speed = speed;
    this.rpm = rpm;
    this.isoDailyConsumption = isoDailyConsumption;
    this.auxiliaryConsumption = auxiliaryConsumption;
    this.measuredIsoConsumption = measuredIsoConsumption;
    this.medianMeasuredConsumption = medianMeasuredConsumption;
  }

}
